// src/components/layout/Header.tsx
import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  Search,
  Bell,
  ChevronDown,
} from 'lucide-react';
import { usePageContext } from '../../contexts/PageContext';
import { useAuth } from '../../contexts/AuthContext';
import { SectionPermissionWrapper } from '../common/SectionPermissionWrapper';
import { PERMISSIONS_LIST } from '@/utils/roles';
// Header Component
export const Header: React.FC = () => {
  const { currentPage, collapsed, showHeader } = usePageContext();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { user } = useAuth();
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  if (!showHeader) return null;

  return (
    <header className={`h-20 transition-all duration-200 flex items-center justify-between fixed sm:static right-0 bg-primary-50 sm:bg-transparent p-4 pl-16 sm:p-0 z-10 ${collapsed ? 'left-0 sm:left-16' : 'left-0 sm:left-64'} ${currentPage === 'Asset Manager' ? 'pl-16 sm:pl-64':''}`}>
        <h1 className="text-xl sm:text-lg sm:text-xl font-semibold text-slate-800">{currentPage}</h1>
        
        <div className="flex items-center gap-4">
          <div className="relative hidden md:block">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
            <input
              type="text"
              placeholder="Search..."
              className="w-64 pl-10 pr-4 py-2 bg-white border border-slate-200 rounded-lg text-sm"
            />
          </div>

          <button className="relative p-3 bg-white hover:bg-blue-100 rounded-full">
            <Bell className="h-5 w-5" />
            <span className="absolute top-2 right-3 h-2 w-2 bg-orange-500 rounded-full"></span>
          </button>

          <div className="relative">
            <button
              onClick={() => setIsDropdownOpen(prev => !prev)}
              className="flex items-center space-x-2 py-1.5 px-2 bg-white hover:bg-blue-100 rounded-full"
            >
              <div className="h-8 w-8 rounded-full bg-gradient-to-br from-orange-100 to-pink-100 flex items-center justify-center">
                <span className="text-sm font-medium text-orange-700">{user?.fullName?.split(' ').slice(0, 2).map(name => name.charAt(0)).join('')}</span>
              </div>
              <ChevronDown className="h-4 w-4" />
            </button>

            {isDropdownOpen && (
              <div ref={dropdownRef} className="absolute z-40 right-0 mt-2 w-48 bg-white rounded-xl border border-slate-200 py-1">
                <Link to="/profile" className="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-50" onClick={() => setIsDropdownOpen(false)}>Profile</Link>
                <SectionPermissionWrapper permission={PERMISSIONS_LIST.VIEW_SETTINGS}>
                  <Link to="/settings" className="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-50" onClick={() => setIsDropdownOpen(false)}>Settings</Link>
                </SectionPermissionWrapper>
              </div>
            )}
          </div>
        </div>
    </header>
  );
};
